import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { obterDadosDoUsuario } from "utils/functions";
import { postSignTerm, getOcorrenciaCRM } from "services/ec";
import { trackTraceException } from "services/trackInsights";
import { useHistory } from "react-router-dom";
import AuthContext from "../auth";
import VAContext from "../va";
import { ModalError } from "../../components";
import { ROUTES } from "../../utils/constants";

const ECContext = React.createContext({
  isLoaded: false,
  doSaveTerm: () => {},
  isInLocation: false,
  setIsInLocation: () => {},
  unidadeId: null,
  selectedContract: null,
  lastLocaleUser: null,
  setLastLocaleUser: () => {},
  extraParams: null,
  loading: false,
  setLoading: () => {},
  ocorrenciaCRM: null,
  setOcorrenciaCRM: () => {}
});

export const ECContextProvider = ({ children }) => {
  const { user } = useContext(AuthContext);
  const {
    unidadeId,
    statusNowTag,
    selectedContract,
    extraParams,
    ocorrenciaCRM,
    setOcorrenciaCRM
  } = useContext(VAContext);
  const history = useHistory();
  const [isInLocation, setIsInLocation] = useState(false);
  const [lastLocaleUser, setLastLocaleUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isError, setIsError] = useState(false);

  const doSaveTerm = async () => {
    const dataUser = await obterDadosDoUsuario();

    const returnBack = {
      idUnidade: unidadeId,
      cpf: user?.profile?.preferred_username,
      numeroOcorrencia: ocorrenciaCRM,
      navegador: dataUser.navegador,
      sistemaOperacional: dataUser.sistemaOperacional,
      ip: dataUser.ip,
      geolocalizacao: `${lastLocaleUser?.latitude} ${lastLocaleUser?.longitude}`,
      tipoCliente: "principal"
    };

    if (user && user.isSoftauth) {
      returnBack.cliente = {
        nome: user.name,
        cpfCnpj: user.cpfCnpj,
        tipo: user.tipo,
        telefone: user.telefone,
        Email: user.email
      };
      returnBack.tipoCliente = "procurador";
      returnBack.CpfCnpjCliente = user.CpfCnpjCliente;
    }

    return postSignTerm(returnBack, unidadeId);
  };

  const loadOcorrencia = async () => {
    if (loading || ocorrenciaCRM) {
      if (ocorrenciaCRM) {
        setIsLoaded(true);
      }
      return;
    }
    try {
      setLoading(true);
      const checklistResponseBack = (await getOcorrenciaCRM(unidadeId)).data;
      setOcorrenciaCRM(checklistResponseBack.numeroOcorrencia);
      setIsLoaded(true);
    } catch (error) {
      setIsError(true);
      trackTraceException("loadOcorrencia", error);
    } finally {
      setLoading(false);
    }
  };

  const value = React.useMemo(
    () => ({
      isLoaded,
      doSaveTerm,
      isInLocation,
      setIsInLocation,
      unidadeId,
      statusNowTag,
      selectedContract,
      lastLocaleUser,
      setLastLocaleUser,
      extraParams,
      loadOcorrencia,
      loading,
      setOcorrenciaCRM,
      ocorrenciaCRM
    }),
    [
      isLoaded,
      doSaveTerm,
      isInLocation,
      setIsInLocation,
      unidadeId,
      statusNowTag,
      selectedContract,
      lastLocaleUser,
      setLastLocaleUser,
      extraParams,
      loadOcorrencia,
      loading,
      setOcorrenciaCRM,
      ocorrenciaCRM
    ]
  );

  return (
    <ECContext.Provider value={value}>
      {children}
      <ModalError
        open={isError}
        onButtonClick={() => {
          setIsError(false);
          history.replace(ROUTES.HOME);
        }}
        message="Erro ao carregar a ocorrência. Tente novamente mais tarde."
        buttonName="Sair"
      />
    </ECContext.Provider>
  );
};

ECContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default ECContext;
